import { UPDATE_ROUTE, UPDATE_THEME } from '../types'

const state = {
  darkMode: window.localStorage.getItem('dark_mode') === 'true',
  route: '',
}

const getters = {
  darkMode: (state) => {
    return state.darkMode && state.route === 'ControlConsole'
  },
}

const mutations = {
  [UPDATE_THEME](state, payload) {
    state.darkMode = payload
    window.localStorage.setItem('dark_mode', payload)
  },
  [UPDATE_ROUTE](state, payload) {
    state.route = payload
  },
}

export default {
  state,
  getters,
  mutations,
}
